import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Observable, Subscription } from 'rxjs'
import { map } from 'rxjs/operators'
import { FetchSearchTypesRequest } from './../../shared/shared.actions'
import { getSearchTypes } from './../../shared/shared.select'
import { SearchType } from '@shared/shared.types'
import { TranslateService } from '@ngx-translate/core'
import { UpdateField } from '@containers/search-results/search-results.actions'
import { getSearchState } from '@containers/search-results/search-results.selectors'

@Component({
  selector: 'search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
})
export class SearchComponent implements OnInit, OnDestroy {
  public searchTypes: any[]
  public searchTypeKeys: string[]
  public searchType: string
  public searchKeyword: string
  route$: Subscription
  public searchState$: Subscription
  @Input() public fluid: boolean
  @Output() public onSubmit: EventEmitter<void> = new EventEmitter()

  constructor(
    public store: Store<any>,
    private router: Router,
    private route: ActivatedRoute,
    public translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.searchTypes = [
      {
        id: SearchType.PROPERTY_RDN,
        label: this.translateService.instant('PROPERTY_RDN'),
      },
      {
        id: SearchType.LICENSE,
        label: this.translateService.instant('LICENSE'),
      },
      {
        id: SearchType.PAYABLE,
        label: this.translateService.instant('PAYABLE'),
      },
      {
        id: SearchType.PAYMENT,
        label: this.translateService.instant('PAYMENT'),
      },
    ]

    this.searchTypeKeys = this.searchTypes.map(({ id }) => id)

    this.searchState$ = this.store
      .pipe(select(getSearchState))
      .subscribe((state) => {
        this.searchKeyword = state.getIn(['queryParams', 'keyword'])
        this.searchType = state.getIn(['queryParams', 'type'])
      })
  }

  ngOnDestroy() {
    this.searchState$.unsubscribe()
  }

  goToSearch() {
    this.onSubmit.emit()
    this.router.navigate(['/search'], {
      queryParams: {
        keyword: this.searchKeyword,
        type: this.searchType,
      },
    })
  }

  handleSearchTypeChange(type: SearchType) {
    this.store.dispatch(new UpdateField('type', type, 'queryParams'))
  }

  handleSearchKeywordChange(keyword: string) {
    this.store.dispatch(new UpdateField('keyword', keyword, 'queryParams'))
  }
}
